/**
 * assets/board-components.js (v2)
 * -----------------------------------------------------------------------
 * Lógica del widget "Armá tu Setup": cada fila tiene un botón "+" que
 * abre un modal con tarjetas de producto (imagen, nombre, precio). Al
 * elegir una tarjeta se actualiza el precio/etiqueta de la fila, valida
 * que la lija (obligatoria) esté seleccionada, e intercepta el submit
 * del formulario de producto para agregar la tabla + los componentes
 * elegidos al carro en un solo paso, usando la Ajax Cart API de Shopify
 * (/cart/add.js).
 *
 * Súbelo a Online Store > Themes > Edit code > Assets, y cárgalo al
 * final de theme.liquid (antes de </body>) con:
 *
 *   {{ 'board-components.js' | asset_url | script_tag }}
 *
 * O, si tu tema usa secciones con defer/module, agrégalo como:
 *   <script src="{{ 'board-components.js' | asset_url }}" defer="defer"></script>
 */

(function () {
  // NOTA: el 20% off por "setup completo" ya NO se aplica desde este
  // script. Es un Automatic Discount nativo de Shopify ("Setup Completo
  // 20% OFF (automático)"), configurado en Shopify Admin con un monto
  // mínimo de compra ($118.960) sobre las colecciones tablas, lijas,
  // rodamientos, trucks y pernos. Shopify lo aplica y lo retira solo,
  // tanto en el carro como en el checkout — no necesita ayuda de JS.

  function formatCLP(amount) {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0,
    }).format(amount || 0);
  }

  function initWidget(widget) {
    var errorEl = widget.querySelector('[data-board-components-error]');
    var defaultErrorText = errorEl ? errorEl.textContent : '';
    var bundleHintEl = widget.querySelector('[data-board-components-bundle-hint]');
    var bundleReadyEl = widget.querySelector('[data-board-components-bundle-ready]');
    var cartNoticeEl = widget.querySelector('[data-board-components-cart-notice]');
    var quotaErrorEl = widget.querySelector('[data-board-components-quota-error]');
    var rows = widget.querySelectorAll('[data-component-row]');
    var inputs = [];
    var productId = parseInt(widget.getAttribute('data-product-id') || '0', 10);
    var freeGripTag = widget.getAttribute('data-free-grip-tag') || '';

    // Cupo de lijas gratis disponible para ESTA tabla, calculado a partir
    // de lo que ya hay en el carrito (boards que califican para el mismo
    // esquema de lija gratis, menos lijas gratis ya usadas). null mientras
    // no se ha consultado /cart.js todavía (no bloqueamos por defecto).
    var freeGripQuotaRemaining = null;
    var refreshCardsDisabled = function () {};

    function fetchCart() {
      return fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .catch(function () {
          return null;
        });
    }

    function computeFreeGripQuota(cart) {
      if (!cart || !cart.items || !freeGripTag) return null;
      var qualifyingBoards = 0;
      var freeGripsUsed = 0;
      cart.items.forEach(function (item) {
        var props = item.properties || {};
        if (props._free_grip_tag === freeGripTag && props._free_grip !== 'true') {
          qualifyingBoards += item.quantity || 0;
        }
        if (props._free_grip === 'true' && props._free_grip_tag === freeGripTag) {
          freeGripsUsed += item.quantity || 0;
        }
      });
      // +1 porque la tabla que se está viendo todavía no está en el carro,
      // pero califica para el mismo esquema de lija gratis.
      return qualifyingBoards + 1 - freeGripsUsed;
    }

    function renderCartNotice(cart) {
      if (!cartNoticeEl || !cart || !cart.items || !productId) return;
      var sameProductQty = 0;
      cart.items.forEach(function (item) {
        if (item.product_id === productId && item.properties && item.properties._setup_armado) {
          sameProductQty += item.quantity || 0;
        }
      });
      if (sameProductQty > 0) {
        cartNoticeEl.innerHTML =
          'Ya tienes ' + sameProductQty + ' de esta tabla con su setup armado en el carrito. ' +
          '<a href="/cart">Ver carrito</a> antes de agregar otra, para no duplicar por error.';
        cartNoticeEl.hidden = false;
      } else {
        cartNoticeEl.hidden = true;
      }
    }

    function refreshCartContext() {
      fetchCart().then(function (cart) {
        if (!cart) return;
        freeGripQuotaRemaining = computeFreeGripQuota(cart);
        renderCartNotice(cart);
        refreshCardsDisabled();
      });
    }

    function isSetupComplete() {
      // "Completo" = las 5 filas tienen una selección real (variant id
      // no vacío). La fila "No agregar" deja el input vacío a propósito,
      // así que cuenta igual que no haber seleccionado nada.
      return inputs.length > 0 && inputs.every(function (input) {
        return !!input.value;
      });
    }

    function updateBundleStatus() {
      var complete = isSetupComplete();
      if (bundleHintEl) bundleHintEl.hidden = complete;
      if (bundleReadyEl) bundleReadyEl.hidden = !complete;
    }

    function closeAllModals() {
      widget.querySelectorAll('[data-component-modal]').forEach(function (m) {
        m.hidden = true;
      });
      document.body.classList.remove('board-components-modal-open');
    }

    rows.forEach(function (row) {
      var key = row.getAttribute('data-component-row');
      var modal = row.querySelector('[data-component-modal="' + key + '"]');
      var input = row.querySelector('[data-component-input="' + key + '"]');
      var priceEl = row.querySelector('[data-component-price="' + key + '"]');
      var labelEl = row.querySelector('[data-component-label="' + key + '"]');
      var thumbEl = row.querySelector('[data-component-thumb="' + key + '"]');
      var changeBtn = row.querySelector('.board-components__change');
      var openBtns = row.querySelectorAll('[data-component-open="' + key + '"]');
      var cards = modal ? modal.querySelectorAll('[data-component-card]') : [];
      var defaultLabel = labelEl ? labelEl.getAttribute('data-default-label') || labelEl.textContent : '';

      if (input) {
        inputs.push(input);
        // Guardamos a qué fila pertenece este input (grip, bearings,
        // wheels, trucks, bolts) para poder reconstruir, desde el carro,
        // qué categorías quedan presentes cuando el cliente edita el
        // carro manualmente — ver guardCompleteSetupDiscount() al final
        // del archivo.
        input.dataset.componentKey = key;
      }

      function openModal() {
        if (!modal) return;
        closeAllModals();
        modal.hidden = false;
        document.body.classList.add('board-components-modal-open');
      }

      function closeModal() {
        if (!modal) return;
        modal.hidden = true;
        document.body.classList.remove('board-components-modal-open');
      }

      openBtns.forEach(function (btn) {
        btn.addEventListener('click', openModal);
      });

      if (modal) {
        modal.querySelectorAll('[data-component-close="' + key + '"]').forEach(function (btn) {
          btn.addEventListener('click', closeModal);
        });
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          var variantId = card.getAttribute('data-variant-id');
          var price = parseFloat(card.getAttribute('data-price') || '0');
          var isFree = variantId && card.getAttribute('data-free') === 'true';
          var title = card.getAttribute('data-title') || '';
          var image = card.getAttribute('data-image') || '';

          // Si el cupo de lijas gratis ya está agotado, no permitir elegir
          // una tarjeta gratis (la tarjeta también queda visualmente
          // deshabilitada por refreshCardsDisabled, esto es la red de
          // seguridad por si el click llega de todos modos).
          if (isFree && freeGripQuotaRemaining !== null && freeGripQuotaRemaining <= 0) {
            if (quotaErrorEl) {
              quotaErrorEl.textContent =
                'Ya alcanzaste el cupo de lijas gratis para las tablas que tienes en el carrito. Elige una lija a precio normal, o agrega otra tabla que califique para sumar otro cupo.';
              quotaErrorEl.hidden = false;
            }
            return;
          }
          if (quotaErrorEl) quotaErrorEl.hidden = true;

          if (input) {
            input.value = variantId;
            input.dataset.free = isFree ? 'true' : 'false';
          }

          if (priceEl) {
            priceEl.classList.toggle('board-components__price--free', !!isFree);
            if (isFree) {
              priceEl.textContent = 'GRATIS';
            } else {
              priceEl.textContent = price > 0 ? '+' + formatCLP(price) : '+$0';
            }
          }

          if (labelEl) labelEl.textContent = variantId ? title : defaultLabel;

          if (thumbEl) {
            if (variantId && image) {
              thumbEl.innerHTML = '<img src="' + image + '" alt="" loading="lazy">';
              thumbEl.classList.add('board-components__add-icon--filled');
            } else {
              thumbEl.textContent = '+';
              thumbEl.classList.remove('board-components__add-icon--filled');
            }
          }

          if (changeBtn) changeBtn.hidden = !variantId;
          row.classList.toggle('board-components__row--selected', !!variantId);

          if (errorEl) {
            errorEl.textContent = defaultErrorText;
            errorEl.hidden = true;
          }
          closeModal();
          updateBundleStatus();
        });
      });
    });

    updateBundleStatus();

    // Tarjetas marcadas como "gratis" en cualquier fila (hoy solo aplica a
    // la fila de lija) — se habilitan/deshabilitan según el cupo vigente.
    var freeCards = widget.querySelectorAll('[data-component-card][data-free="true"]');
    refreshCardsDisabled = function () {
      var blocked = freeGripQuotaRemaining !== null && freeGripQuotaRemaining <= 0;
      freeCards.forEach(function (card) {
        card.classList.toggle('board-components__card--disabled', blocked);
        card.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      });
    };

    // Consulta el carrito actual al cargar la página: actualiza el cupo de
    // lijas gratis y muestra el aviso de "ya tienes esta tabla en el
    // carrito" si corresponde (Issue #3 — evitar que el cliente tenga que
    // adivinar qué quedó pendiente al volver de /cart).
    refreshCartContext();

    // Cerrar modal al hacer click en el overlay o con Escape.
    widget.addEventListener('click', function (e) {
      if (e.target.classList && e.target.classList.contains('board-components__modal-overlay')) {
        closeAllModals();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllModals();
    });

    var productForm = widget.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (!productForm) {
      console.warn('[board-components] no se encontró el form de producto — revisa el selector.');
      return;
    }

    var addToCartBtn =
      productForm.querySelector('[data-btn-addToCart]') ||
      productForm.querySelector('button[type="submit"][name="add"]') ||
      productForm.querySelector('#product-add-to-cart') ||
      productForm.querySelector('[type="submit"]');

    var submitting = false;

    function gatherExtraItems(bundleId, setupComplete) {
      var extraItems = [];
      inputs.forEach(function (input) {
        if (input.value) {
          var properties = { _setup_armado: bundleId };
          if (setupComplete) properties._armado_completo = 'true';
          // Si esta fila es la lija de regalo, etiquetamos la línea para
          // poder calcular el cupo de lijas gratis en la próxima visita
          // (ver computeFreeGripQuota arriba).
          if (input.dataset.free === 'true' && freeGripTag) {
            properties._free_grip = 'true';
            properties._free_grip_tag = freeGripTag;
          }
          // Etiqueta de categoría (grip/bearings/wheels/trucks/bolts), para
          // poder verificar desde /cart si el setup sigue completo después
          // de que el cliente edite el carro manualmente.
          if (input.dataset.componentKey) {
            properties._setup_component = input.dataset.componentKey;
          }
          extraItems.push({
            id: parseInt(input.value, 10),
            quantity: 1,
            properties: properties,
          });
        }
      });
      return extraItems;
    }

    function handleAddToCart(e) {
      if (submitting) {
        e.preventDefault();
        return;
      }

      // 1. Reunir componentes opcionales elegidos.
      var bundleId = 'lt_setup_' + Date.now();
      var setupComplete = isSetupComplete();
      var extraItems = gatherExtraItems(bundleId, setupComplete);

      // Si no eligió ningún componente opcional, deja que el form siga su
      // flujo normal (el tema agrega solo la tabla, como siempre).
      if (extraItems.length === 0) return;

      // A partir de aquí, SIEMPRE tomamos control: bloqueamos el submit
      // nativo/del tema y manejamos el agregado al carro nosotros mismos,
      // para asegurarnos de que los componentes elegidos también se agreguen.
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      submitting = true;
      if (addToCartBtn) addToCartBtn.disabled = true;

      var formData = new FormData(productForm);
      formData.append('properties[_setup_armado]', bundleId);
      if (setupComplete) formData.append('properties[_armado_completo]', 'true');
      // Etiquetamos también la tabla con el esquema de lija gratis al que
      // califica, para poder calcular el cupo disponible en la próxima
      // visita (ver computeFreeGripQuota / Issue #1 — evita que se puedan
      // sumar más lijas gratis que tablas calificantes en el carrito).
      if (freeGripTag) formData.append('properties[_free_grip_tag]', freeGripTag);

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) {
            console.error('[board-components] fallo agregando la TABLA', d);
            throw new Error(d.description || d.message || 'Error agregando la tabla al carro');
          });
          return r.json();
        })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: extraItems }),
          });
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) {
            console.error('[board-components] fallo agregando COMPONENTES', d);
            throw new Error(d.description || d.message || 'Error agregando componentes al carro');
          });
          return r.json();
        })
        .then(function () {
          // El 20% off por setup completo es un Automatic Discount nativo
          // de Shopify (ver nota al inicio del archivo) — se aplica solo
          // si el subtotal de las colecciones del setup llega al mínimo,
          // sin que este script tenga que hacer nada.
          return fetch('/cart.js').then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          submitting = false;
          if (addToCartBtn) addToCartBtn.disabled = false;

          // Abrimos el carrito lateral del tema (Halo): el click nativo en
          // el ícono del carro solo agrega la clase "cart-sidebar-show" al
          // <body> (confirmado en assets/theme.js, función initSidebarCart),
          // así que lo hacemos SIEMPRE, sin condición — esto abre el drawer
          // visualmente sin importar nada más.
          document.body.classList.add('cart-sidebar-show');

          // Si además existe el helper que refresca el contenido del drawer,
          // lo usamos para que se vea el carro actualizado al instante.
          var refreshedDrawer = false;
          if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
            window.sharedFunctions.updateSidebarCart(cart);
            refreshedDrawer = true;
          } else {
            console.warn(
              '[board-components] window.sharedFunctions.updateSidebarCart no está disponible — el carrito lateral se abrió pero puede no mostrar el contenido actualizado. Revisa la consola del navegador (F12) para más detalles.'
            );
          }

          // Aviso propio como respaldo — nunca navegamos a /cart. Si el
          // drawer no se pudo refrescar, al menos el cliente tiene
          // confirmación visual y un link directo si prefiere ir al carro.
          if (!refreshedDrawer && cartNoticeEl) {
            cartNoticeEl.innerHTML = '✅ Agregado al carrito. <a href="/cart">Ver carrito</a>';
            cartNoticeEl.hidden = false;
          }
        })
        .catch(function (err) {
          console.error('[board-components]', err);
          submitting = false;
          if (addToCartBtn) addToCartBtn.disabled = false;
          if (errorEl) {
            errorEl.textContent =
              (err && err.message) ||
              'No pudimos agregar uno de los componentes elegidos. Intenta de nuevo o quita esa opción.';
            errorEl.hidden = false;
          }
        });
    }

    // Capturamos el click en el botón de "Agregar al carrito" en fase de
    // captura, a nivel de documento. Esto se ejecuta ANTES que cualquier
    // listener propio del tema (ej. el custom element <product-form> con
    // su propio AJAX add-to-cart) — sin esto, el tema puede agregar solo
    // la tabla y nuestra lógica de componentes nunca llega a ejecutarse.
    if (addToCartBtn) {
      document.addEventListener(
        'click',
        function (e) {
          if (e.target === addToCartBtn || addToCartBtn.contains(e.target)) {
            handleAddToCart(e);
          }
        },
        true
      );
    }

    // Red de seguridad: si el form se envía por otra vía (ej. tecla Enter
    // en un campo), igual interceptamos en fase de captura.
    productForm.addEventListener('submit', handleAddToCart, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-board-components]').forEach(initWidget);
  });

  // El 20% off por "setup completo" ya no se controla desde JS: ahora es
  // un Automatic Discount nativo de Shopify con un monto mínimo de compra
  // sobre las colecciones del setup. Shopify lo aplica y lo retira solo
  // en el carro y en el checkout, así que ya no hace falta ninguna
  // guardia ni banner en /cart para mantenerlo sincronizado.
})();